"use client";

import { useAuth } from "src/lib/contexts/AuthContext";
import { lazyComponent } from "src/lib/LazyModules";

// Signed-in visitors only; the portal and docs layouts preload it for them (src/lib/LazyModules.tsx).
const WorkspaceMenu = lazyComponent("signedInShell", "WorkspaceMenu");

const PortalWorkspaceSwitcher = ({ showPortalLink = false }: { showPortalLink?: boolean }) => {
  const { authState } = useAuth();

  if (!authState?.user) return null;

  return (
    <div className="shrink-0 border-y border-border p-2">
      <WorkspaceMenu showPortalLink={showPortalLink} />
    </div>
  );
};

export default PortalWorkspaceSwitcher;
